import { render } from "./GroupsPage.vue?vue&type=template&id=3667f58b"
import script from "./GroupsPage.vue?vue&type=script&lang=js"
export * from "./GroupsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__